import { useEffect, useReducer, useRef } from 'react'
import { LocationEditorCallbacks, type LocationEditorProps } from '../../types'

import { computeInitialState } from './computeInitialState'
import { createLocationEditorReducer } from './createLocationEditorReducer'

export function useLocationEditorState(props: LocationEditorProps) {
  const {
    onSelectAsset,
    onConfirmLowAccuracy,
    onFixInvalidAddress,
    onShowAdjustAddressModal,
    onTextChange,
    onCopyCoordinates,
    location,
    assets,
    onClose,
    getLocation,
    setLoading,
  } = props

  const callbacksRef = useRef<LocationEditorCallbacks>({
    onSelectAsset,
    onConfirmLowAccuracy,
    onFixInvalidAddress,
    onTextChange,
    onCopyCoordinates,
    onShowAdjustAddressModal,
    onClose,
    getLocation,
    setLoading,
  })

  useEffect(() => {
    callbacksRef.current = {
      onSelectAsset,
      onConfirmLowAccuracy,
      onFixInvalidAddress,
      onTextChange,
      onCopyCoordinates,
      onShowAdjustAddressModal,
      onClose,
      getLocation,
      setLoading,
    }
  }, [
    onSelectAsset,
    onConfirmLowAccuracy,
    onFixInvalidAddress,
    onTextChange,
    onCopyCoordinates,
    onShowAdjustAddressModal,
    onClose,
    getLocation,
    setLoading,
  ])

  const [state, dispatch] = useReducer(
    createLocationEditorReducer(callbacksRef),
    props,
    computeInitialState,
  )

  useEffect(() => {
    dispatch({ type: 'react/location:update', location })
  }, [location])

  useEffect(() => {
    dispatch({ type: 'react/assets:update', assets })
  }, [assets])

  return { state, dispatch }
}
